// Module
var code = "<title>Account Settings</title> <div class=\"h100\" ng-controller=\"AccountSettingsCtrl\" ng-cloak> <vue-component class=\"h100\" name=\"Account\" v-on-user-updated=\"onUserUpdated\"/> </div> ";
// Exports
module.exports = code;